import "./App.css";
import 'rsuite/dist/rsuite-no-reset-rtl.min.css';
import Root from "./routes/rootRoute";
import { CustomProvider, Container } from 'rsuite';

function App() {
  return (
    <CustomProvider theme="light">
      <Container className="app">
        <Root />
      </Container>
    </CustomProvider>
  );
}

export default App;
